export const FOOD_PREFERENCE_FILTERS = "foodPreferenceFilters";
export const RESULT_BILAN_DATA = "resultBilanData";
export const BILAN_DATA = "bilanData";
export const CODE_PROMO = "codePromo";
export const DEFAULT_PROMOTION = "promotion";
export const CLIENT_IP = "ip";
export const PROJECT_ENV_DEVELOPMENT = "development";
export const MAIL_CAPTURE_MODAL = "mail_capture_modal";
export const REFERRAL_MODAL = "referral_modal";
export const MAIL_CAPTURE_SUBMITTED = "mail_capture_submitted";
export const REFERRAL_FORM_SUBMITTED = "referral_modal_submitted";
export const BAR_MAIL_CAPTURE_CODE = "mail_capture_bar";
export const POPUP_MAIL_CAPTURE_CODE = "mail_capture_popup";
export const BAR_REFERRAL_CODE = "referral_bar";
export const POPUP_REFERRAL_CODE = "referral_popup";
export const BAR_BILAN_CODE = "bilan_bar";
export const BAR_PROMO_BAR_CODE = "promo_bar";
export const MODAL_OPENING_DELAY = 5000;
